
import Layout from '@/module_dashboard/views/Layout.vue';
import { checkUserLogin } from '@/module_user/router';

const routes = [
    {
        path: "/fsb-assessment",
        component: Layout,
        beforeEnter: checkUserLogin,
         name: 'FSB Assessments',
        children: [
            {
                path: '/fsb-assessment',
                component: () => import("./views/Assessments.vue"),
                name: 'Assessments'
            },
            {
                path: '/fsb-assessment/add',
                component: () => import("./views/CreateAssessment.vue"),
                name: 'CreateAssessment'
            },
            {
                path: '/end-fsb-assessment',
                component: () => import("./views/EndAssessment.vue"),
                name: 'EndFsbAssessment'
            },
            {
                path: '/fsb-assessment/viewReport/:id',
                component: () => import("./components/Report.vue"),
                name: 'ViewFsbReport',
                props: true 
            },
            {
                path: '/fsb-assessment/view/:id',
                component: () => import("./views/ViewAssessment.vue"),
                name: 'ViewFsbAssessment',
                props: true 
            }
        ]
    }
]

export default routes;